import { HttpErrorResponse } from '@angular/common/http';
import { ClientTranslatableException, isClientTranslatableException } from '@softline/core';
import { DeliveryNoteQueryRow } from '../types/delivery-note-query-row';

const GENERIC_DELETE_KEY = 'SALES_DOCUMENT.DELETE.EXCEPTION';
const NOT_POSSIBLE_KEY = '#WWS_DELIVERY_NOTE_CORRECTION.DELETE.NOT_POSSIBLE';

/** `F` = fakturiert: the backend refuses to delete an invoiced document, a correction included. */
export function isInvoiced(row: DeliveryNoteQueryRow | null | undefined): boolean {
  return row?.delivery_note?.status?.code === 'F';
}

/** The delete endpoint wraps every refusal in one generic key; until it names the reason (backend ticket 456325)
 *  the user gets a text that says what it usually is. Any other error stays as it is. */
export function deleteErrorOf(error: unknown): unknown {
  const cte =
    error instanceof ClientTranslatableException
      ? error.cte
      : error instanceof HttpErrorResponse && isClientTranslatableException(error.error)
        ? error.error
        : null;
  if (!cte || cte.key !== GENERIC_DELETE_KEY) return error;
  return new ClientTranslatableException({ key: NOT_POSSIBLE_KEY, params: cte.params ?? {} }, error as Error);
}
